import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import { entityReviver, handleFetchErrors } from './utils'

export function fetchCodafWells(): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/well`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(handleFetchErrors)
        .then(r => {
            return r.text().then(data => {
                return JSON.parse(data, entityReviver)
            })
        })
        .catch(() => {
            globalNotification.error(i18n(`Unable to fetch entity.`))
            return null
        })
}

export function deleteWellNoIntervention(wellId: number | undefined): Promise<any> {
    return fetch(`/services/plugin-static-data-manager/well/deleteWellNoIntervention/${wellId}/`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    })
}
